import { PaymentMethod } from "../../../../common/enums";
import { type FormText } from "./types";

export const formTextMap = new Map<PaymentMethod, FormText>([
  [
    PaymentMethod.Check,
    {
      editWorkflowTitle: "Edit check instructions",
      paymentMethodText: "Check",
    },
  ],
  [
    PaymentMethod.ACH,
    {
      editWorkflowTitle: "Edit ACH direct deposit instructions",
      paymentMethodText: "ACH direct deposit",
    },
  ],
  [
    PaymentMethod.Wire,
    {
      editWorkflowTitle: "Edit wire transfer instructions",
      paymentMethodText: "Wire transfer",
    },
  ],
]);
